export const DATE_LABELS: Record<number, string> = {
  6: 'Last 6 Months',
  12: 'Last Year',
  18: 'Last 18 Months',
  24: 'Last 2 Years',
};

export interface Sale {
  _id: { month: number; year: number };
  total_sales: number;
}

export interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: string[];
    backgroundColor: string;
    borderColor: string;
    pointBackgroundColor: string;
    borderWidth: number;
    fill: boolean;
  }[];
}

export function buildChartData(sales: Sale[]): ChartData {
  return {
    labels: sales.map((s) => {
      const month = new Date(s._id.year, s._id.month - 1).toLocaleString('default', { month: 'short' });
      const year = String(s._id.year).slice(-2);
      return `${month} '${year}`;
    }),
    datasets: [
      {
        label: 'Monthly Sales',
        data: sales.map((s) => (s.total_sales / 100).toFixed(2)),
        backgroundColor: 'rgba(236,23,79,0.15)',
        borderColor: 'rgba(236,23,79,1)',
        pointBackgroundColor: 'rgba(236,23,79,1)',
        borderWidth: 2,
        fill: true,
      },
    ],
  };
}

function numberFormat(number: number | string, decimals = 0, decPoint = '.', thousandsSep = ','): string {
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(decimals) ? 0 : Math.abs(decimals);
  const toFixedFix = (n: number, prec: number) => String(Math.round(n * Math.pow(10, prec)) / Math.pow(10, prec));
  const parts = (prec ? toFixedFix(n, prec) : String(Math.round(n))).split('.');
  if (parts[0].length > 3) {
    parts[0] = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSep);
  }
  if ((parts[1] || '').length < prec) {
    parts[1] = (parts[1] || '') + new Array(prec - (parts[1] || '').length + 1).join('0');
  }
  return parts.join(decPoint);
}

export function formatTooltip(tooltipItem: any, chart: any): string {
  const datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
  return `${datasetLabel}: AUD ${numberFormat(tooltipItem.yLabel, 2)}`;
}

export function formatTick(value: number): string {
  if (value >= 1000) {
    const k = value / 1000;
    return `$${k % 1 === 0 ? numberFormat(k) : numberFormat(k, 1)}k`;
  }
  return `$${numberFormat(value)}`;
}
